'use strict';

var $ = require('jquery');

var buttonWaitingClass = 'btn--isWaiting';
var waitingIndicatorClass = 'btn__waitingIndicator';

function setupButtons($buttons) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	setupTheseButtons($buttons);

	return $buttons;
};
function setupTheseButtons($buttons) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	$buttons.each(function() {
		var $this = $(this);
		if ($this.find('.' + waitingIndicatorClass).length == 0) {
			$this.append('<span class='+waitingIndicatorClass+'/>');
		}
	});

	return $buttons;
};

function destroyTheseButtons($buttons) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	$('.' + waitingIndicatorClass, $buttons).remove();
}

function toggleTheseButtons($buttons, state) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	$($buttons).toggleClass(buttonWaitingClass, state);
}

function resetButtons($buttons) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	setupTheseButtons($('.' + buttonWaitingClass));
}

function attachHandlers($buttons) {
	if (typeof $buttons === 'string') {
		$buttons = $($buttons);
	}
	$(document).on('jsfAjaxBegin submit', function(event) {
		setupButtons($buttons);
		toggleTheseButtons($buttons, true);
	});

	$(document).on('jsfAjaxAlways', function(event) {
		toggleTheseButtons($buttons, false);
		destroyTheseButtons($buttons);
	});
}

module.exports = {
	setupButtons: setupButtons,
	setupTheseButtons: setupTheseButtons,
	toggleTheseButtons: toggleTheseButtons,
	resetButtons: resetButtons,
	attachHandlers: attachHandlers
}
